
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Phys } from '../../canvas/entities/Phys';
import { RelativeTo } from '../../canvas/entities/Physical';
import { ConnectTarget } from './ConnectTarget';
import { Connector } from './Connector';

export class ConnectorMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start(): void {
        this.burden(
            this.objects.createRelation(Connector, '@from', 'attachee', 'attached'),
            this.objects.createRelation(Connector, '@to', 'attachee', 'attached'),
            this.objects.createTrigger('ConnectTarget.UpdateConnectors')
                .for(ConnectTarget)
                .onChangesTo('x' as any, 'y' as any, 'r' as any, 'width' as any, 'height' as any)
                .doForEach(this.updateConnectTargetConnectors),
            this.objects.createTrigger('ConnectTarget.CheckConnectors')
                .for(ConnectTarget)
                .onManipulated('translate', 'scale', 'rotate')
                .doForEach(this.checkConnectTargetConnectors),
            this.objects.createTrigger('Connector.CheckTargets')
                .for(Connector)
                .onManipulated('translate', 'scale', 'rotate', 'tweak')
                .doForEach(this.checkConnectorConnectTargets),
        );
    }

    private updateConnectTargetConnectors = (t: ConnectTarget) => {
        const attached = Phys.from(t.relations('attached')).polarize(Connector);
        for (const c of attached) {
            c.applyOffsets();
        }
    };

    private checkConnectTargetConnectors = (c: ConnectTarget) => {
        const attached = Phys.from(c.relations('attached')).polarize(Connector);
        for (const h of attached) {
            this.checkConnection(h, c);
        }
    };

    private checkConnectorConnectTargets = (c: Connector) => {
        const targets = Phys.from(c.relations('attachee')).polarize(ConnectTarget);
        for (const t of targets) {
            this.checkConnection(c, t);
        }
    };

    private checkConnection = (c: Connector, t: ConnectTarget) => {
        const tb = t.bounds(RelativeTo.Model);
        const [start, end] = c.createFigure();
        if (c.fromId === t.id && !tb.contains(start)) {
            c.fromId = null;
            c.fromOffset = null;
            c.fromRotation = 0;
        }
        if (c.toId === t.id && !tb.contains(end)) {
            c.toId = null;
            c.toOffset = null;
            c.toRotation = 0;
        }
    };
}
